import React, { useEffect, useRef, useState } from "react";
import {
  onChangeLabelSymbol,
  onChangeLabelEnabled,
  PointLabelPlacementArray,
} from "./LabelToggleVM";
import "./style.scss";
import { Checkbox, FormControl, FormControlLabel, Input, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";
import { CheckBox } from "@mui/icons-material";
const LabelToggleWidget = (props: { layer: any; view: any }) => {
  const { layer, view } = props;

  const [currentField, setcurrentField] = useState("");
  const [labelEnabled, setlabelEnabled] = useState(layer.labelsVisible);
  const [customLabelEnabled, setCustomlabelEnabled] = useState(false);
  const [labelSize, setLabelSize] = useState(12);
  const [color, setColor] = useState("#fafafa");
  const [outlineColor, setOutlineColor] = useState("#1d20de");
  const [labelPlacement, setLabelPlacement] = useState("above-right");
  const originalLabelingInfo = useRef(layer.labelingInfo);
  const layerGeometryType = useRef(layer.geometryType);

  useEffect(() => {
    if (layerGeometryType?.current === "polygon") {
      setLabelPlacement("always-horizontal");
    } else if (layerGeometryType?.current === "polyline") {
      setLabelPlacement("center-along");
    }
    view.map.when((map) => {
      let listLayerObject = JSON.parse(
        localStorage.getItem(`listLayers-${map.portalItem.id}`)
      );
      if (listLayerObject !== null) {
        if(listLayerObject.hasOwnProperty(layer.title)){
        if (listLayerObject[layer.title].hasOwnProperty("labelInfo")) {
          let labelInfoObject = JSON.parse(
            listLayerObject[layer.title].labelInfo
          );
          onChangeLabelSymbol(
            layer,
            labelInfoObject.field,
            labelInfoObject.labelSize,
            labelInfoObject.outlineColor,
            labelInfoObject.color,
            labelInfoObject.labelPlacement
          );
          setcurrentField(labelInfoObject.field);
          setLabelSize(labelInfoObject.labelSize);
          setOutlineColor(labelInfoObject.outlineColor);
          setColor(labelInfoObject.color);
          setCustomlabelEnabled(true);
          if (layerGeometryType?.current === "point") {
            setLabelPlacement(labelInfoObject.labelPlacement);
          }
        }
      }
      }
    });
  }, []);
  useEffect(() => {
    if (!customLabelEnabled) {
      layer.labelingInfo = originalLabelingInfo.current;
      if (sessionStorage.getItem(`${layer.title}-useCustomLabel`)) {
        sessionStorage.removeItem(`${layer.title}-useCustomLabel`);
      }
      return;
    }
    sessionStorage.setItem(
      `${layer.title}-useCustomLabel`,
      JSON.stringify({
        label: "true",
        field: currentField,
        labelPlacement: labelPlacement,
        labelSize: labelSize,
        outlineColor: outlineColor,
        color: color,
      })
    );
    onChangeLabelSymbol(
      layer,
      currentField,
      labelSize,
      outlineColor,
      color,
      labelPlacement
    );
  }, [
    layer,
    customLabelEnabled,
    labelSize,
    currentField,
    outlineColor,
    color,
    labelPlacement,
  ]);

  if (layer.hasOwnProperty("fields")) {
    let fields = [];
    layer.popupTemplate.fieldInfos.forEach((field: any) => {
      if (field.visible)
        fields.push(
          <MenuItem
            id={`option-${field.fieldName}`}
            key={`option-${field.fieldName}`}
            value={field.fieldName}
          >
            {field.label}
          </MenuItem>
        );
    });
    let placementOptions = [];
    let placementSelectArray = [];
    if (layerGeometryType.current === "point") {
      PointLabelPlacementArray.forEach((item) => {
        placementOptions.push(
          <MenuItem
            id={`${layer.id}-placement-option-${item}`}
            key={`${layer.id}-placement-option-${item}`}
            value={item}
          >
            {item}
          </MenuItem>
        );
      });
      placementSelectArray = [
        <>
        <FormControl fullWidth>
          <InputLabel id={`layer-label-placement`}>Label placement </InputLabel>
          <Select
          variant="standard"
          labelId={`layer-label-placement`}
            // className="selectData"
            // style={{ marginRight: "8px", marginLeft: "2px" }}
            value={labelPlacement}
            onChange={(e: any) => {
              setLabelPlacement(e.target.value);
            }}
          >
            {placementOptions}
          </Select>
          </FormControl>
        </>,
      ];
    }

    return (
      <div className="label-toggle-widget">
          <FormControlLabel
          control={
            <Checkbox
            id={`checkbox-label-${layer.id}`}
            checked={labelEnabled}
            onChange={(e) => onChangeLabelEnabled(e, layer, setlabelEnabled)}
          ></Checkbox>
          }
          label="Label visible?"/>
        <div>
          <FormControlLabel control={
                      <Checkbox
                      id={`checkbox-custom-label-${layer.id}`}
                      checked={customLabelEnabled}
                      onChange={(e) => {
                        setCustomlabelEnabled((prev) => !prev);
                      }}
                    ></Checkbox>

          }
          label="Use custom label"
           />

        </div>
        {customLabelEnabled ? (
          <>
              <FormControl fullWidth>
              <InputLabel id ="layer-label-field">Field for Label </InputLabel>
              <Select
              variant="standard"
              labelId="layer-label-field"
                value={currentField}
                onChange={(e: any) => {
                  setcurrentField(e.target.value);
                }}
              >
                {!currentField ? (
                  <MenuItem
                    id={"option-noField"}
                    key={"option-noField"}
                    value={""}
                  >
                    Select New Label
                  </MenuItem>
                ) : (
                  ""
                )}
                {fields}
              </Select>
              </FormControl>
            <div>
              <InputLabel 
              htmlFor="layer-label-size-input" id="layer-label-size" style={{ lineHeight: "2.2" }}>
                Label size
                </InputLabel>
                <Stack direction="row">
              <Input
              fullWidth
              id="layer-label-size-input"
                // className="label-size-input"
                type="number"
                value={labelSize}
                onChange={(e) => {
                  setLabelSize(parseInt(e.target.value));
                }}
              ></Input>
              <Typography> pt</Typography>
              </Stack>
            </div>
              <InputLabel htmlFor="layer-outline-input-label"
              // style={{ lineHeight: "2.2" }}
              >Outline </InputLabel>
              <Input
              fullWidth
              id="layer-outline-input-label"
                // className="color-input"
                type="color"
                placeholder={outlineColor}
                defaultValue={outlineColor}
                onChange={(e) => setOutlineColor(e.target.value)}
              />{" "}
              <InputLabel htmlFor="layer-label-fill-color" style={{ lineHeight: "2.2" }}>Fill </InputLabel>
              <Input
              fullWidth
              id="layer-label-fill-color"
                // className="color-input"
                type="color"
                placeholder={color}
                defaultValue={color}
                onChange={(e) => setColor(e.target.value)}
              />{" "}
            {placementSelectArray}
          </>
        ) : (
          ""
        )}
      </div>
    );
  } else {
    return (
      <div>
        <div>Label Selection Not Available</div>
      </div>
    );
  }
};
export default LabelToggleWidget;
